import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { trackPageView } from './analytics';

/**
 * Fires a page_view on every route (pathname) change. Query-string-only
 * changes are not page views. A no-op until initAnalytics has run; the landing
 * route is tracked by initAnalytics itself.
 */
export const useAnalyticsPageTracking = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    trackPageView(pathname);
  }, [pathname]);
};
